import ConfirmModal from 'views/components/ConfirmModal'
import { getResourceString } from '../../../../components/resource'
import useRemovePolicyHandler from '../../../effects/remove-policy-from-group'
import { Group, ResourcePolicy } from '../../../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type RemovePolicyModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onConfirm: () => void,
	group: Group,
	policy: ResourcePolicy,
}

export default function RemovePolicyModal( { onCancel, onSuccess, group, policy, onConfirm }: RemovePolicyModalProps ) {
	const removePolicy = useRemovePolicyHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Remove Policy From Group Modal - Click - Remove', {} )
		const result = await removePolicy( policy.id )
		onConfirm()
		return result
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Remove Policy From Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ConfirmModal
			message={`You are about to remove "${policy.role.name} => ${getResourceString( policy.resource )}" from ${group.name}. Do you want to proceed?`}
			onConfirm={async() => await handleSubmit()}
			buttonColor="danger"
			buttonText="Remove"
			onCancel={handleCancel}
			onSuccess={onSuccess}
		/>
	)
}
